<template>
  <div class="app-input-time">
    <span class="input-title" v-if="label">{{ label }}</span>
    <AppTimepicker
      v-model="time"
      hour-label="HH"
      minute-label="MM"
      apm-label="AM/PM"
      auto-scroll
      :disabled="disabled"
      :format="format"
      :class="{ invalid: errorMessages }"
      @input="handleOnChangeTime"
      @click:clear="handleOnClearTime"
      :debug-mode="false"
    />
    <span v-if="errorMessages" class="error--text">{{ errorMessages }}</span>
  </div>
</template>

<script>
import { Helper } from "@/services/helper";
export default {
  name: "TimeInput",

  model: {
    prop: "time",
    action: "update",
  },

  props: {
    value: {
      type: String,
      default: "",
    },
    format: {
      type: String,
      default: "hh:mm A",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: null,
    },

    label: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    time: "",
  }),

  mounted() {
    this.handleOnFormatValueToObject(this.value);
  },

  methods: {
    handleOnChangeTime(time) {
      this.$emit("change", Helper.convert12to24(time));
    },

    handleOnFormatValueToObject(value) {
      console.log("value", value);
      const time = value.split(":");
      const hh = this.convert24hTo12h(parseInt(time[0])) || 12;
      const mm = time[1] || 0;
      const A = time[0] > 12 ? "PM" : "AM";
      this.time = { hh, mm, A };
    },

    convert24hTo12h(hour) {
      if (!hour) {
        hour = 12;
      }
      if (hour > 12) {
        hour -= 12;
      }

      return Helper.to2Digit(hour);
    },

    handleOnClearTime() {
      this.handleOnChangeTime("");
    },
  },
};
</script>

<style lang="scss" scoped src="./styles.scss" />
